<template>
  <v-dialog
    v-model="visible"
    @keydown.esc="close"
    persistent
    scrollable
    max-width="480"
    style="z-index: 6"
  >
    <v-form ref="addEmailForm" @submit.prevent="submit">
      <v-card class="edit-comm-card">
        <v-card-title class="edit-comm-header">
          <span class="edit-comm-title">Uredi kontakt</span>
          <v-spacer></v-spacer>
          <v-btn icon small @click="close">
            <v-icon color="#94A3B8">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-6 pb-2" v-if="comm">
          <v-select
            outlined
            dense
            hide-details
            label="Tip"
            v-model="comm.type"
            :items="availableComms"
            item-text="text"
            item-value="id"
            :rules="[rules.req]"
            class="edit-comm-field mb-4"
            @change="setAvailableUsage()"
          />
          <v-text-field
            outlined
            dense
            hide-details
            label="Vrijednost"
            v-model="comm.value"
            :rules="[rules.req]"
            class="edit-comm-field mb-4"
          />
          <v-select
            v-if="comm.type !== undefined"
            outlined
            dense
            hide-details
            multiple
            label="Koristi se za"
            v-model="comm.usage"
            :items="availableUsage"
            item-text="text"
            item-value="id"
            :rules="[rules.req]"
            class="edit-comm-field"
          />
        </v-card-text>

        <v-card-actions class="px-6 pb-5 pt-4 d-flex justify-end">
          <v-btn text class="edit-comm-cancel-btn" @click="close">Odustani</v-btn>
          <v-btn elevation="0" class="edit-comm-save-btn" :loading="submitting" :disabled="submitting" type="submit">Spremi</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { df } from '@/plugins/firebase'
import { clone } from '@/plugins/utils'
import rules from '@/plugins/rules'
import state from '@/state'

export default {
  components: { },
  inject: ['showMsgBox', 'showLoader', 'hideLoader'],
  data: () => ({
    visible: false,
    location: undefined,
    submitting: false,
    comm: undefined,
    type: undefined,
    availableUsage: undefined,
    selectedUsage: [],
    value: undefined,
    rules: {
      req: rules.req(),
      eq: rules.eq
    },
    availableComms: [],
    listeners: []
  }),
  mounted () {
  },
  methods: {
    setAvailableUsage () {
      this.availableComms.forEach(ac => {
        if (ac.id === this.comm.type) {
          this.availableUsage = ac.available_usage
        }
      })
    },
    open (comm, availableComms) {
      this.availableComms = clone(availableComms)

      this.availableComms.forEach(ac => {
        if (ac.id === comm.type) {
          this.availableUsage = ac.available_usage
        }
      })

      this.comm = comm
      this.visible = true
      this.submitting = false
    },
    close () {
      this.resetInputs()
    },
    resetInputs () {
      this.comm = undefined
      this.visible = false
      this.location = undefined
    },
    async submit () {
      if (!this.comm) {
        return
      }
      const tblId = this.comm.id
      const docRef = df.doc(`company_communications/${state.getCurrentCompany().id}/communications/${tblId}`)

      try {
        await docRef.set(
          {
            id: tblId,
            type: this.comm.type,
            usage: this.comm.usage,
            value: this.comm.value
          }
        )
      } catch (err) {
        console.error('Error saving email: ', err)
      }

      this.resetInputs()
    }
  }

}
</script>
<style scoped>
.edit-comm-card {
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
  overflow: hidden;
}

.edit-comm-header {
  padding: 20px 24px 16px !important;
  border-bottom: 1px solid #EEF2F5;
}

.edit-comm-title {
  font-size: 16px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
  letter-spacing: 0.2px;
}

.edit-comm-field.v-text-field--outlined >>> fieldset {
  border-color: #E2E8F0 !important;
  border-radius: 8px !important;
}

.edit-comm-field.v-text-field--outlined:hover >>> fieldset {
  border-color: #B0BEC5 !important;
}

.edit-comm-field.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #00838F !important;
  border-width: 2px !important;
}

.edit-comm-field >>> .v-input__slot {
  background: #F8FAFC !important;
}

.edit-comm-cancel-btn {
  color: #64748B !important;
  text-transform: none !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  margin-right: 8px;
}

.edit-comm-save-btn {
  background: rgba(0, 188, 212, 0.08) !important;
  color: #00838F !important;
  border: 1.2px solid #00b3be !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  height: 38px !important;
  padding: 0 20px !important;
}

.edit-comm-save-btn:hover {
  background: rgba(0, 179, 190, 0.12) !important;
}
</style>
